import React, { useState } from 'react';
import axios from 'axios';
import { KeyRound, Loader2 } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ChangePasswordForm = () => {
  const { language } = useLanguage();
  const { token } = useAuth();
  const T = (fr, en) => (language === 'fr' ? fr : en);
  const [form, setForm] = useState({ current: '', next: '', confirm: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) {
      toast.error(T('Le nouveau mot de passe doit contenir au moins 8 caractères', 'New password must be at least 8 characters'));
      return;
    }
    if (form.next !== form.confirm) {
      toast.error(T('Les mots de passe ne correspondent pas', 'Passwords do not match'));
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/auth/change-password`,
        { current_password: form.current, new_password: form.next },
        { headers: { Authorization: `Bearer ${token}` } });
      toast.success(T('Mot de passe modifié avec succès', 'Password changed successfully'));
      setForm({ current: '', next: '', confirm: '' });
    } catch (error) {
      toast.error(error.response?.data?.detail || T('Erreur lors du changement', 'Change failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4 max-w-md" data-testid="change-password-form">
      <div>
        <Label htmlFor="current-password">{T('Mot de passe actuel', 'Current password')}</Label>
        <Input
          id="current-password" type="password" value={form.current}
          onChange={(e) => setForm({ ...form, current: e.target.value })}
          className="mt-1.5 h-11" required
          data-testid="current-password-input"
        />
      </div>
      <div>
        <Label htmlFor="next-password">{T('Nouveau mot de passe (8 caractères min.)', 'New password (min. 8 characters)')}</Label>
        <Input
          id="next-password" type="password" value={form.next}
          onChange={(e) => setForm({ ...form, next: e.target.value })}
          className="mt-1.5 h-11" required minLength={8}
          data-testid="new-password-input"
        />
      </div>
      <div>
        <Label htmlFor="confirm-new-password">{T('Confirmer le nouveau mot de passe', 'Confirm new password')}</Label>
        <Input
          id="confirm-new-password" type="password" value={form.confirm}
          onChange={(e) => setForm({ ...form, confirm: e.target.value })}
          className="mt-1.5 h-11" required minLength={8}
          data-testid="confirm-password-input"
        />
      </div>
      <div className="flex justify-end pt-2">
        <Button type="submit" className="btn-primary" disabled={loading} data-testid="change-password-submit">
          {loading ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <KeyRound className="w-4 h-4 mr-2" />}
          {T('Changer le mot de passe', 'Change password')}
        </Button>
      </div>
    </form>
  );
};
